<div
  class="kh-carousel"
  khA11yCarousel
  [khA11yLabel]="'A11Y_CAROUSEL.CAROUSEL' | translate"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">
  <button
    *ngIf="showNav"
    type="button"
    class="kh-carousel-prev"
    data-testid="carousel-prev-button"
    [disabled]="!canGoPrevious()"
    [khA11yLabel]="'A11Y_CAROUSEL.PREVIOUS' | translate"
    (click)="previous()">
    <span class="kh-carousel-nav-text" [innerHTML]="prevNavText"></span>
  </button>

  <div
    class="kh-carousel-stage-outer"
    data-testid="carousel-stage"
    [class.is-dragging]="isDragging"
    [style.padding-left.px]="stagePaddingPx"
    [style.padding-right.px]="stagePaddingPx"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointercancel)="onPointerUp($event)">
    <div
      class="kh-carousel-stage"
      [style.transform]="stageTransform"
      [style.transition-duration.ms]="stageTransitionMs"
      [style.column-gap.px]="itemGapPx">
      <div
        class="kh-carousel-item"
        *ngFor="let slide of slides; let i = index"
        [style.flex]="'0 0 ' + itemFlexBasis"
        [class.active]="i >= activeIndex && i < activeIndex + visibleItems">
        <ng-container *ngTemplateOutlet="slide.templateRef"></ng-container>
      </div>
    </div>
  </div>

  <div class="kh-carousel-dots" *ngIf="showDots" khA11yGroup>
    <button
      type="button"
      class="kh-carousel-dot"
      data-testid="carousel-dot"
      *ngFor="let dotIndex of dotIndexes"
      [class.active]="isDotActive(dotIndex)"
      khA11yCarouselDot
      [khA11yCarouselDotActive]="isDotActive(dotIndex)"
      [khA11yCarouselDotIndex]="dotIndex"
      (click)="goToDot(dotIndex)">
      <span khA11yHidden></span>
    </button>
  </div>

  <button
    *ngIf="showNav"
    type="button"
    class="kh-carousel-next"
    data-testid="carousel-next-button"
    [disabled]="!canGoNext()"
    [khA11yLabel]="'A11Y_CAROUSEL.NEXT' | translate"
    (click)="next()">
    <span class="kh-carousel-nav-text" [innerHTML]="nextNavText"></span>
  </button>
</div>
